import React, { useContext, useMemo, useState } from 'react'
import { Box, Typography, Grid, TextField, Button, Alert } from '@mui/material'
import {Controller, useFormContext} from 'react-hook-form'
import { WhatsappDataContext } from '../WhatsappMessageContent';
import { CloudUpload } from '@mui/icons-material';
import { Helpers } from '../../../../../../services/Helpers';
import ImgUploadDialog from '../../../../../../components/ImgUpload/imgUpload';
import DocumentUploadDialog from '../../../../../../components/fileUpload/DocumentUpload';

const TemplateContent = () => {
    const { selectedTemplate, templateVariables,} = useContext(WhatsappDataContext);
    const { control,setValue } = useFormContext();
    
    // Group variables by type - memoized to prevent re-renders
    const headerMediaVar = useMemo(() => templateVariables.find(v => v.type === 'media'), [templateVariables]);
    const textVariables = useMemo(() => templateVariables.filter(v => v.type === 'text'), [templateVariables]);
    
    const [imgOpen, setImgOpen] = useState(false);
    const uploadFolder = 'whatsapp/campaign';
    const [docOpen, setDocOpen] = useState(false);
    const [currentMediaType, setCurrentMediaType] = useState(null);

    const fileCategory = useMemo(() => {
        if (!currentMediaType) return 'document';
        if (currentMediaType === 'video') return 'video';
        return 'document';
    }, [currentMediaType]);

    const openUpload = (mediaType) => {
            if (!mediaType) return;
            if (mediaType === 'image') setImgOpen(true);
            else setDocOpen(true);
        };
    
        const closeImg = () => setImgOpen(false);
        const closeDoc = () => setDocOpen(false);
    
        const extractUploadedUrl = (data) => {
            if (!data) return '';
            if (data.fileUrl) return data.fileUrl;
            if (data.Location) return data.Location;
            if (data.url) return data.url;
            if (data.fullUrl) return data.fullUrl;
            if (data.imageBaseUrl && data.imageDirectory && data.imageName) {
                return `${data.imageBaseUrl}${data.imageDirectory}${data.imageName}`;
            }
            if (data.imageDirectory && data.imageName) {
                return `${Helpers.ImagePathUrl()}${data.imageDirectory}${data.imageName}`;
            }
            if (data.imageName) {
                return `${Helpers.ImagePathUrl()}/${uploadFolder}/${data.imageName}`;
            }
            return '';
        };
    
        const onUploadResponse = (data) => {
            console.log('Uploaded data received in MediaContent:', data);
            const url = extractUploadedUrl(data);
            if (url) {
                setValue('whatsappTemplateParams.header_media', url, { shouldDirty: true, shouldValidate: true });
            }
            closeImg();
            closeDoc();
        };
  return (
    <>
        {selectedTemplate && (
            <>
                {/* Dynamic Parameter Fields */}
                {templateVariables.length > 0 && (
                    <Box>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2, fontSize: '0.8rem' }}>
                            Template Parameters
                        </Typography>
                        <Grid container spacing={2}>
                            {/* Media Variable */}
                            {headerMediaVar && (
                                <Grid item xs={12} >
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={12} md={9}>
                                            <Controller
                                                name={`whatsappTemplateParams.${headerMediaVar.key}`}
                                                control={control}
                                                rules={{ required: `${headerMediaVar.label} is required` }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <TextField
                                                        {...field}
                                                        fullWidth
                                                        label={headerMediaVar.label}
                                                        size="small"
                                                        InputProps={{
                                                            style: { fontSize: '0.8rem' }
                                                        }}
                                                        InputLabelProps={{
                                                            style: { fontSize: '0.8rem' },
                                                            shrink: true
                                                        }}
                                                        error={!!error}
                                                        // helperText={error ? error.message : (headerMediaVar.example ? `Example: ${headerMediaVar.example}` : '')}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            {headerMediaVar?.format && (headerMediaVar?.format != 'video' && headerMediaVar?.format != 'audio') ?
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    startIcon={<CloudUpload />}
                                                    fullWidth
                                                    disabled={!headerMediaVar?.format}
                                                    onClick={() => openUpload(headerMediaVar?.format)}
                                                >
                                                    {headerMediaVar?.format ? `Upload ${headerMediaVar?.format}` : 'Select media type'}
                                                </Button>
                                                :
                                                <Alert severity="info">
                                                    <Typography sx={{fontSize:'0.8rem'}}>{`Collect ${headerMediaVar?.format} link from Team and paste it in the Media URL field.`}</Typography>
                                                </Alert>
                                            }
                                        </Grid>
                                        
                                    </Grid>
                                </Grid>
                            )}
                            {/* Text Variables */}
                            {textVariables.map((variable, index) => (
                                <Grid item xs={variable.buttonType ? 12 : 4} key={variable.key}>
                                    <Controller
                                        name={`whatsappTemplateParams.${variable.key}`}
                                        control={control}
                                        rules={{ required: `${variable.label} is required` }}
                                        render={({ field, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label={variable.label}
                                                size="small"
                                                multiline={variable.buttonType === 'URL'}
                                                rows={variable.buttonType === 'URL' ? 2 : 1}
                                                InputProps={{
                                                    style: { fontSize: '0.8rem' }
                                                }}
                                                InputLabelProps={{
                                                    style: { fontSize: '0.8rem' }       
                                                }}
                                                error={!!error}
                                                helperText={error ? error.message : (variable.example ? `Example: ${variable.example}` : '')}
                                            />
                                        )}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                )}
            </>
        )}

        <ImgUploadDialog
            open={imgOpen}
            onClose={closeImg}
            imgData={{ path: uploadFolder }}
            imgUploadResponse={onUploadResponse}
        />
        <DocumentUploadDialog
            open={docOpen}
            onClose={closeDoc}
            uploadData={{ path: uploadFolder }}
            onUploadResponse={onUploadResponse}
            fileCategory={fileCategory}
            dialogTitle={fileCategory ? `Upload ${fileCategory}` : 'Upload File'}
        />
    </>
  )
}

export default TemplateContent
